import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
  ListItem,
  HStack,
  OrderedList
} from '@chakra-ui/react'
import { Layout } from '../../components'

const Faqs = () => {
  return (
    <Layout noMb title="Frequently Asked Questions">
      <Accordion allowToggle>
        {Questions.map(({ question, answer, trunc }) => (
          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    overflow="hidden"
                    py="1.2rem"
                    _hover={{ border: 'none', outline: 'none' }}
                    _active={{ border: 'none', outline: 'none' }}
                    _focus={{ border: 'none', outline: 'none' }}>
                    <Box w="70%" color="black" fontSize="1.2rem" flex="1" textAlign="left">
                      {question}
                      {!isExpanded && (
                        <Text
                          overflow="hidden"
                          maxW="100%"
                          isTruncated
                          w="calc(90%)"
                          fontSize="1.1rem"
                          color="#888888">
                          {trunc}
                        </Text>
                      )}
                    </Box>
                    <AccordionIcon color={isExpanded ? '#4D80E4' : '#B2B2B2'} w="2rem" h="2rem" />
                  </AccordionButton>
                </h2>
                <AccordionPanel mt="-0.5rem" pt={0} fontSize="1.1rem" pb={4}>
                  {answer}
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </Layout>
  )
}

export { Faqs }

const Questions = [
  {
    question: 'What is Kappa?',
    trunc: ' Kappa is an Online motor  insurance platform. Currently, our',
    answer: (
      <>
        <Text>
          Kappa is an Online motor insurance platform, where we provide Third-party Insurance.
        </Text>
        <Text mt="1rem">
          Our goal is to deliver quality insurance services all from the comfort of your devices.
        </Text>
      </>
    )
  },
  {
    question: 'How do I get Started on Kappa?',
    trunc: 'Getting started is pretty easy. Visit our website www.Kappa.',
    answer: <Text>Getting started is pretty easy. Visit our website www.Kappa.com to begin.</Text>
  },
  {
    question: 'What Insurance Plans Can I buy on Kappa?',
    trunc: 'Our insurance platform provides access to Third party Motor insurance ',
    answer: <Text>Our insurance platform provides access to Third party Motor insurance</Text>
  },
  {
    question: 'What Does my Motor Insurance Policy Cover?',
    trunc: ' Kappa provides Third Party Motor insurance for both private and c',
    answer: (
      <>
        <Text>
          Kappa provides Third Party Motor insurance for both private and commercial vehicles. This
          insurance product covers the policyholder against third-party property damage (up to a
          limit of N1million).
        </Text>
        <Text d="block">
          This policy also covers reimbursement of legal fees if policy holder is prosecuted in
          court over an accident resulting in a valid claim.
        </Text>
      </>
    )
  },
  {
    question: 'Why Should I Insure my Vehicle?',
    trunc: `Third party insurance is a mandatory requirement for all vehicles on Nigerian roads. Also,
    this is necessary as it saves you the cost of damages done to other vehicles for which you
    were at fault.`,
    answer: (
      <Text>
        Third party insurance is a mandatory requirement for all vehicles on Nigerian roads. Also,
        this is necessary as it saves you the cost of damages done to other vehicles for which you
        were at fault.
      </Text>
    )
  },
  {
    question: 'What is the Period of My Motor Insurance Policy?',
    trunc: `Kappa’s motor insurance policy is valid for a year and can be renewed before it’s expiry
    date. This policy is at a fixed fee of #5,000 yearly.`,
    answer: (
      <Text>
        Kappa’s motor insurance policy is valid for a year and can be renewed before it’s expiry
        date. This policy is at a fixed fee of #5,000 yearly.
      </Text>
    )
  },
  {
    question: 'How Can I Make a Claim?',
    trunc: 'To make a claim, Kindly reach out to us on +2349037957970 or email pretotype@trium.ng.',
    answer: (
      <>
        <Text>
          To make a claim, Kindly reach out to us on +2349037957970 or email pretotype@trium.ng.
        </Text>
        <Text>
          Our administrators must be notified as soon as possible, preferably within 48 hours of the
          incident.
        </Text>
      </>
    )
  },
  {
    question: 'What Documents Do I Need to be Able to Buy Insurance Using  Your Platform?',
    trunc:
      'To buy motor insurance, your Bank Verification Number and Vehicle Plate Number is needed.',
    answer: (
      <>
        <Text>
          To buy motor insurance, your Bank Verification Number and Vehicle Plate Number is needed.
        </Text>
      </>
    )
  },
  {
    question: 'How do I get My Insurance Certificate?',
    trunc:
      'Upon successful registration, your insurance certificate will be sent to your email address.',
    answer: (
      <Text>
        Upon successful registration, your insurance certificate will be sent to your email address.
      </Text>
    )
  }
]

// const Questions = [
//   {
//     question: 'What is Kappa?',
//     trunc: ' Kappa is an Online motor and gadget insurance platform. Currently, our',
//     answer: (
//       <>
//         <Text>
//           Kappa is an Online motor and gadget insurance platform. Currently, our gadget insurance
//           plan covers only Samsung devices, Iphone devices and Apple Laptops. For Motor Insurance,
//           we provide Third-party Insurance.
//         </Text>
//         <Text mt="1rem">
//           Our goal is to deliver quality insurance services all from the comfort of your devices.
//         </Text>
//       </>
//     )
//   },
//   {
//     question: 'How do I get Started on Kappa?',
//     trunc: 'Getting started is pretty easy. Visit our website www.Kappa.',
//     answer: <Text>Getting started is pretty easy. Visit our website www.Kappa.com to begin.</Text>
//   },
//   {
//     question: 'What Insurance Plans Can I buy on Kappa?',
//     trunc: 'Our insurance platform provides access to Third party Motor insurance and G',
//     answer: (
//       <Text>
//         Our insurance platform provides access to Third party Motor insurance and Gadget insurance
//         for Samsung and Apple devices.{' '}
//       </Text>
//     )
//   },
//   {
//     question: 'What Does my Motor Insurance Policy Cover?',
//     trunc: ' Kappa provides Third Party Motor insurance for both private and c',
//     answer: (
//       <>
//         <Text>
//           Kappa provides Third Party Motor insurance for both private and commercial vehicles. This
//           insurance product covers the policyholder against third-party property damage (up to a
//           limit of N1million).
//         </Text>
//         <Text d="block">
//           This policy also covers reimbursement of legal fees if policy holder is prosecuted in
//           court over an accident resulting in a valid claim.
//         </Text>
//       </>
//     )
//   },
//   {
//     question: 'What Does my Gadget Insurance Policy Cover?',
//     trunc: 'Kappa’s gadget insurance policy covers the cost of repairs and replacement which',
//     answer: (
//       <Text>
//         Kappa’s gadget insurance policy covers the cost of repairs and replacement which may arise
//         as a result of theft or damage.{' '}
//       </Text>
//     )
//   },
//   {
//     question: 'Why Should I Insure my Vehicle?',
//     trunc: `Third party insurance is a mandatory requirement for all vehicles on Nigerian roads. Also,
//     this is necessary as it saves you the cost of damages done to other vehicles for which you
//     were at fault.`,
//     answer: (
//       <Text>
//         Third party insurance is a mandatory requirement for all vehicles on Nigerian roads. Also,
//         this is necessary as it saves you the cost of damages done to other vehicles for which you
//         were at fault.
//       </Text>
//     )
//   },
//   {
//     question: 'Why Should I Insure my Gadget?',
//     trunc: `Insuring your gadgets with Kappa is a cost effective way to protect your gadgets in the
//     event of loss or damage.`,
//     answer: (
//       <Text>
//         Insuring your gadgets with Kappa is a cost effective way to protect your gadgets in the
//         event of loss or damage.
//       </Text>
//     )
//   },
//   {
//     question: 'What is the Period of My Motor Insurance Policy?',
//     trunc: `Kappa’s motor insurance policy is valid for a year and can be renewed before it’s expiry
//     date. This policy is at a fixed fee of #5,000 yearly.`,
//     answer: (
//       <Text>
//         Kappa’s motor insurance policy is valid for a year and can be renewed before it’s expiry
//         date. This policy is at a fixed fee of #5,000 yearly.
//       </Text>
//     )
//   },
//   {
//     question: 'What is the Period of My Gadget Insurance Policy?',
//     trunc: 'Our gadget insurance policy comes in three (3) forms',
//     answer: (
//       <>
//         <Text>Our gadget insurance policy comes in three (3) forms:</Text>
//         <OrderedList mt="0.5rem">
//           <ListItem>
//             Monthly: This lasts for a month and can be renewed at the end of every month.
//           </ListItem>
//           <ListItem>
//             Quarterly: This lasts for a period of three months and can be renewed at the end of
//             every quarter.
//           </ListItem>
//           <ListItem>
//             Annually: This lasts for a period of one year and can be renewed at the end of the year
//           </ListItem>
//         </OrderedList>
//       </>
//     )
//   },
//   {
//     question: 'How Can I Make a Claim?',
//     trunc: 'To make a claim, Kindly reach out to us on +2349037957970 or email pretotype@trium.ng.',
//     answer: (
//       <>
//         <Text>
//           To make a claim, Kindly reach out to us on +2349037957970 or email pretotype@trium.ng.
//         </Text>
//         <Text>
//           Our administrators must be notified as soon as possible, preferably within 48 hours of the
//           incident.
//         </Text>
//       </>
//     )
//   },
//   {
//     question: 'What Documents Do I Need to be Able to Buy Insurance Using  Your Platform?',
//     trunc: 'The detail we require for gadget insurance is your Bank Verification Number.',
//     answer: (
//       <>
//         <Text>The detail we require for gadget insurance is your Bank Verification Number. </Text>
//         <Text>
//           To buy motor insurance, your Bank Verification Number and Vehicle Plate Number is needed.
//         </Text>
//       </>
//     )
//   },
//   {
//     question: 'How do I get My Insurance Certificate?',
//     trunc:
//       'Upon successful registration, your insurance certificate will be sent to your email address.',
//     answer: (
//       <Text>
//         Upon successful registration, your insurance certificate will be sent to your email address.
//       </Text>
//     )
//   }
// ]
